import { useState } from "react";
import { LineChart, ExternalLink } from "lucide-react";

const MODELS = [
  { key: "100", label: "Windguru" },
  { key: "52", label: "AROME 1.3km" },
  { key: "114", label: "ICON-CH 1km" },
  { key: "3", label: "GFS 13km" },
];

export function WindguruWidget({ spot }) {
  const id = spot?.windguru_id;
  const [model, setModel] = useState("100");

  if (!id) {
    return (
      <div className="bg-white rounded-3xl border border-slate-100 shadow-sm p-6" data-testid="windguru-empty">
        <div className="flex items-center gap-2 mb-2">
          <LineChart className="h-5 w-5 text-sky-600" />
          <h3 className="font-head text-xl font-semibold text-slate-900">Modelli previsionali</h3>
        </div>
        <p className="text-sm text-slate-400">Nessun ID Windguru per questo spot. Seba può aggiungerlo dal pannello.</p>
      </div>
    );
  }

  const src = `https://www.windguru.cz/widget-fcst-iframe.php?s=${id}&m=${model}&wj=knots&tj=c&lng=it&fhours=120&hrsm=2&odh=0&doh=24`;

  return (
    <div className="bg-white rounded-3xl border border-slate-100 shadow-sm overflow-hidden" data-testid="windguru-widget">
      <div className="flex flex-wrap items-center gap-3 px-5 pt-5 pb-3">
        <div className="h-8 w-8 rounded-xl bg-sky-100 flex items-center justify-center">
          <LineChart className="h-4 w-4 text-sky-600" />
        </div>
        <h3 className="font-head text-xl font-semibold text-slate-900">Modelli previsionali · Windguru</h3>
        <a
          href={`https://www.windguru.cz/${id}`}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="windguru-full-link"
          className="ml-auto inline-flex items-center gap-1.5 text-xs font-semibold text-sky-600 hover:text-sky-700"
        >
          Grafici completi <ExternalLink className="h-3.5 w-3.5" />
        </a>
      </div>

      <div className="flex gap-2 px-5 pb-4 overflow-x-auto no-scrollbar">
        {MODELS.map((m) => (
          <button
            key={m.key}
            onClick={() => setModel(m.key)}
            data-testid={`windguru-model-${m.key}`}
            className={`shrink-0 rounded-full px-4 py-1.5 text-sm font-head font-semibold border transition-colors duration-200 ${
              model === m.key
                ? "bg-sky-600 border-sky-600 text-white"
                : "bg-white border-slate-200 text-slate-600 hover:border-sky-300"
            }`}
          >
            {m.label}
          </button>
        ))}
      </div>

      <div className="w-full overflow-x-auto bg-white border-t border-slate-100">
        <iframe
          key={model}
          src={src}
          title={`Windguru ${spot?.name} ${model}`}
          className="w-full"
          style={{ minWidth: 620, height: 340, border: 0 }}
          scrolling="no"
          data-testid="windguru-iframe"
        />
      </div>
      <p className="text-[11px] text-slate-400 px-5 py-3">
        Schema colorato ufficiale Windguru (verde=leggero, giallo/arancio=ottimo, rosso=forte). Cambia modello per confrontare AROME e ICON-CH.
      </p>
    </div>
  );
}
